import React from 'react'
import Servicess from '../components/Servicess';

function Services() {
  return (
    <div className="mt-5">
      <Servicess/>
      </div>
  )
}

export default Services;